type EventCallback = (...args: any[]) => void;

class EventBus {
  private static instance: EventBus;
  private subscribers: { [key: string]: EventCallback[] } = {};

  private constructor() {}

  // singleton을 위한 getInstance 메서드
  static getInstance(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus();
    }
    return EventBus.instance;
  }

  subscribe(eventType: string, callback: EventCallback) {
    if (!this.subscribers[eventType]) {
      this.subscribers[eventType] = [];
    }
    this.subscribers[eventType].push(callback);

    // 구독 취소 함수 반환
    return () => {
      this.subscribers[eventType] = this.subscribers[eventType].filter(
        (cb) => cb !== callback
      );
    };
  }

  publish(eventType: string, ...args: any[]) {
    if (!this.subscribers[eventType]) {
      return;
    }
    this.subscribers[eventType].forEach((callback) => {
      callback(...args);
    });
  }
}

export const eventBus = EventBus.getInstance();

// 이벤트 타입 상수
export const AUTH_EVENTS = {
  ACCESS_TOKEN_REFRESHED: 'ACCESS_TOKEN_REFRESHED',
  USER_LOGGED_IN: 'USER_LOGGED_IN',
} as const;
